import { useEffect } from 'react';
import { useMyShippingAddressesQuery } from 'lib/home/generated/queries';
import { Grid } from 'lib/components';
import { ShippingAddress } from './ShippingAddress';

export const ShippingAddressList = () => {
  const { data, isLoading, isFetching, refetch } = useMyShippingAddressesQuery(undefined, {
    // NOTE: We disable auto-refetching to support our optimistic updates while we what for mutations to settle
    enabled: false
  });
  const { me } = data || {};
  const shippingAddresses = me?.shipping_addresses || [];

  useEffect(() => {
    // Note: Because we have disabled auto-refetching, we need to fetch/refetch the data manually.
    refetch();
  }, []);

  return (
    <>
      {(isLoading || isFetching) && <>Loading shipping addresses...</>}

      {!isLoading && !isFetching && shippingAddresses.length < 1 && (
        <p>You haven't added any shipping addresses yet.</p>
      )}

      {shippingAddresses.length > 0 && (
        <Grid className="shipping-address__list" data-cy="shipping-address-list">
          {shippingAddresses.map(address => (
            <div key={address.id} className="shipping-address__list__item col-span-12">
              <ShippingAddress address={address} />
            </div>
          ))}
        </Grid>
      )}
    </>
  );
};
